import Card from 'react-bootstrap/Card';
import {  useEffect, useState } from 'react';
import { useLocation } from 'react-router';
import EmailOptOutEndpoint from '../../../api/endpoint/EmailOptOutEndpoint';
import Spinner from 'react-bootstrap/Spinner';

export const ConfirmOptOut = () => {
    const [isSuccess, setIsSuccess] = useState<boolean | undefined>(undefined);
    const [message, setMessage] = useState('');

    const location = useLocation();

    useEffect(() => {
        handleOptOut();
    }, []);

    const handleOptOut = async() => {
        try{
            const urlParams = new URLSearchParams(location.search);

            const hash = urlParams.get('user');

            if(!hash || hash === '') {
                setIsSuccess(false);
                setMessage('Error retrieving user email.');
                return;
            }

            const optOutResult = await EmailOptOutEndpoint.OptOutByHash(hash!);

            if(!optOutResult.errors || optOutResult.errors.length == 0) {
                setIsSuccess(true);
                setMessage('You have successfully opted out of emails.');
            }
            else {
                setIsSuccess(false);
                setMessage(optOutResult.errors.join(', '));
            }
        } catch(err) {
            setIsSuccess(false);
            setMessage('Errors returned: ' + (err instanceof Error ? err.message : String(err)));
        }
    };

    return (
        <Card style={{margin:'10% 25%'}}>
            <Card.Body>
                <Card.Title>
                    {isSuccess === undefined &&
                        <Spinner animation="border" role="status">
                            <span className="visually-hidden">Loading...</span>
                        </Spinner>
                    }
                    {isSuccess === true &&
                        <>Success!</>
                    }
                    {isSuccess === false &&
                        <>Error occurred during email opt-out</>
                    }
                </Card.Title>
                <Card.Body>
                    {message}
                </Card.Body>
            </Card.Body>
            
        </Card>
    )
}